import ResourceBase from './../shared/resource-base';
import TcFile from './tcfile-model';
import { deserialize, object, list, serialize, primitive, custom } from 'serializr';
import mobx from 'mobx';
import ModelSchemas from './../shared/model-schema';
import Coordinator from './../coordinators/coordinator-model';
import Agent from './../agents/agent-model';
import AgentProfile from '../agent-profile/agent-profile-model';
import BrokerageProfile from '../agent-profile/brokerage-profile-model';
import _ from 'lodash';

const defaultIncludes = 'filter[include]=agents&filter[include]=coordinator';
export default class TcFileResource extends ResourceBase {
    constructor() {
        super(TcFile);

        ModelSchemas.createCoordinatorSchema(Coordinator);
        ModelSchemas.createAgentProfileSchema(AgentProfile);
        ModelSchemas.createAgentSchema(Agent, {
            agentProfile: object(AgentProfile),
            brokerageProfile: object(BrokerageProfile),
        });
        this.schema = ModelSchemas.createTcFileSchema(TcFile, {
            coordinator: object(Coordinator),
            agents: list(object(Agent)),
            createdBy: primitive(),
            createdOn: primitive(),
            updatedBy: primitive(),
            updatedOn: primitive(),
        });
    }

    getFiles(token, filterOptions) {
        return new Promise((resolve, reject) => {
            filterOptions.include = 'coordinator';
            this.find(token, { filter: JSON.stringify(filterOptions) })
                .then(filesJSON => {
                    let fileModels = [];
                    filesJSON.forEach(fileJSON => {
                        fileModels.push(deserialize(this.schema, fileJSON));
                    });
                    resolve(fileModels);
                })
                .catch(reject);
        }).catch(err => {
            //return err
        });
    }

    getTcFileById(token, tcFileId) {
        return new Promise((resolve, reject) => {
            this.getById(token, tcFileId, defaultIncludes)
                .then(fileJSON => {
                    resolve(deserialize(this.schema, fileJSON));
                })
                .catch(reject);
        });
    }

    saveTcFile(token, tcFileModel, dirtyFields) {
        //TODO:  Replace with isGuid
        if (tcFileModel.tcFileId && tcFileModel.tcFileId.length >= 36) {
            return this.updateExistingFile(token, tcFileModel, dirtyFields);
        } else {
            return this.createNewFile(token, tcFileModel, dirtyFields);
        }
    }

    updateExistingFile(token, tcFileModel, dirtyFields) {
        _.remove(dirtyFields, property => {
            return property === 'coordinator' || property === 'agents';
        });

        const payload = _.pick(tcFileModel, dirtyFields);
        return this.patch(token, tcFileModel.tcFileId, payload);
    }

    createNewFile(token, tcFileModel, dirtyFields) {
        let agent = null;
        //Check if File has an agents
        if (dirtyFields.find(field => field === 'agents')) {
            agent = _.first(tcFileModel.agents);
        }
        //Delete relationships from dirtyFileds
        //TODO:  I don't like this
        delete dirtyFields[dirtyFields.indexOf('agents')];
        delete dirtyFields[dirtyFields.indexOf('coordinators')];

        return this.post(token, _.pick(tcFileModel, dirtyFields)).then(({ body }) => {
            //If there is an Agent, then add an agent to the file
            if (agent) {
                return this.postRelation(token, body.tcFileId, 'agents', mobx.toJS(agent));
            } else {
                Promise.resolve();
            }
        });
    }

    getFilesExtendedSearch(token, filterOptions) {
        filterOptions.include = ['coordinator', 'agents'];
        return new Promise((resolve, reject) => {
            this.request
                .post(`api/TcFiles/extendedSearch`)
                .set('api-key', 'Bearer ' + token)
                .send({
                    searchParameters: filterOptions,
                })
                .then(({ body }) => {
                    let filesJSON = body.TcFiles;
                    let fileModels = [];
                    filesJSON.forEach(fileJSON => {
                        fileModels.push(deserialize(this.schema, fileJSON));
                    });
                    resolve(fileModels);
                })
                .catch(reject);
        });
    }

    getFilesExtendedSearchCount(token, filterOptions) {
        return new Promise((resolve, reject) => {
            this.request
                .post(`api/TcFiles/extendedSearch/count`)
                .set('api-key', 'Bearer ' + token)
                .send({
                    searchParameters: filterOptions,
                })
                .then(({ body }) => {
                    resolve(body.count);
                })
                .catch(reject);
        });
    }

    getTcFilesSearch(token, query) {
        return new Promise((resolve, reject) => {
            this.find(token, query, defaultIncludes)
                .then(fileJSON => {
                    let fileModels = [];
                    fileJSON.forEach(fileJSON => {
                        fileModels.push(deserialize(this.schema, fileJSON));
                    });
                    resolve(fileModels);
                })
                .catch(reject);
        });
    }

    getSubscriberNameSearch(token, query) {
        return new Promise((resolve, reject) => {
            this.request
                .post(`api/tcfiles/findsubscribers?subscribername=${query}`)
                .set('api-key', 'Bearer ' + token)
                .then(fileJSONS => {
                    let fileModels = [];
                    fileJSONS.body.forEach(item => {
                        fileModels.push(item);
                    });
                    resolve(fileModels);
                })
                .catch(reject);
        });
    }

    getFilesCount(token, filterOptions) {
        return new Promise((resolve, reject) => {
            this.findCount(token, {
                where: JSON.stringify(filterOptions.where),
            }) // no filter=, root needs to be where= for /count calls
                .then(result => {
                    resolve(result.count);
                })
                .catch(reject);
        });
    }

    deleteFileById(token, tcFileId) {
        return this.deleteById(token, tcFileId);
    }
}



// WEBPACK FOOTER //
// ./src/files/tcfile-resource.js